import { Group } from "three";

export class GroupObjects extends Group {
	onUploadGroup(object) {
		this.add(object);
	}

	onLookAt(camare) {
		this.traverse((child) => {
			if (child.isMesh) {
				child.lookAt(camare.position);
			}
		});
	}

	onVisibleAnotherChild(newName) {
		this.traverse((child) => {
			if (child.isMesh) {
				if (child.name === newName) {
					child.visible = true;
				} else {
					child.visible = false;
				}
			}
		});
	}
	onVisibleAnotherChildDynamic(planes = []) {
		this.traverse((child) => {
			if (child.isMesh) {
				const planeVisible = planes.find((plane) => plane.name === child.name);
				if (planeVisible !== undefined) {
					child.visible = true;
					child.position.set(planeVisible.position.x, planeVisible.position.y, planeVisible.position.z);
				} else {
					child.visible = false;
				}
			}
		});
	}

	onChangeMaterialPlane(name, beforeName, material) {
		this.traverse((child) => {
			if (child.isMesh) {
				if (child.name === name) {
					child.material = material;
				}
				if (child.name === beforeName) {
					child.material = material;
				}
			}
		});
	}
}
